import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.sort.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-05-10 18:41:07
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-04-11 14:07:13
 * @FilePath     : /marketing-landing-fe/src/global/index.ts
 * @Description  : 未添加文件描述
 */


import 'normalize.css';
import './index.less';
import '@/plugins/styles.less';
import JoJoRouter from '@jojo/router';
import SentryConfig, { customError, Sentry } from '@woulsl/sentry-config'; // import * as Sentry from '@sentry/browser';
// import { Integrations } from '@sentry/tracing';

import sensors from '@woulsl-tools/sensors'; // import { getCurrPlatformText, isJoJoBrowser } from '@/utils';

import Cookie from 'js-cookie';
import { ENV_BASE, envName, sensors_server_url, tagName } from '@/const';
import { qsParse } from '@/utils';
import bridge, { canUseBridge } from '@/utils/bridge';
import Exposure from '@/utils/sensorsPlugin/exposure';

try {
  var Jlocation = new JoJoRouter({
    basePath: ENV_BASE
  });
  console.log('ENV_BASE==', ENV_BASE);

  if (window.JoJo) {
    JoJo.location = Jlocation || window.location;
  } else {
    window.JoJo = {
      location: Jlocation || window.location
    };
  }
} catch (e) {
  customError({
    name: 'global.ts错误',
    message: 'Jlocation初始化错误',
    stack: e.stack
  });
}

try {
  // const { host, pathname } = window.location;
  var query = qsParse();
  var isSentryTest = envName !== 'pro';
  var _a = query.channel,
      channel = _a === void 0 ? 'Undefined' : _a,
      linkId = query.linkId,
      _b = query.channelNo,
      channelNo = _b === void 0 ? '' : _b;
  var uid_1 = Cookie.get('uid');
  Sentry.setTags({
    channel: channel,
    channelNo: channelNo
  });
  /* getCurrPlatformText()
    .then((platform: string) => {
      Sentry.setTag('platform', platform);
    })
    .catch((e) => {
      console.error(e);
    }); */

  if (linkId) {
    Sentry.setTag('linkId', linkId);
  }

  SentryConfig({
    dsn: 'https://2d25b4e66b6c47e08ad7963b1280a26d@sentry.tinman.cn/12',
    sampleRate: isSentryTest ? 1 : 0.1,
    tracesSampleRate: isSentryTest ? 1 : 0.1,
    environment: envName,
    release: tagName,
    ignoreErrors: ['onAndroidBack is not defined', "Cannot read properties of undefined (reading 'event')", 'Event `XMLHttpRequestProgressEvent` (type=error) captured as promise rejection', /\s*null is not an object \(evaluating 'e\.width'\)\s*/i, // 忽略 Cannot read properties of null (reading 'width') 字符串
    /\s*Cannot read properties of null \(reading '(\w+)'\)\s*/i, // 正则忽略该错误
    /\s*WebViewJavascriptBridge is not defined\s*/i, // 排查发现全局没有使用callJSTypeBack，应该是安卓内部默认桥的问题，可忽略
    /\s*callJSTypeBack is not defined\s*/i, // jojo-acount-sdk 错误提示  忽略特定的 JSON 格式
    /\{"status":\s*(-?\d+),\s*"errorCode":\s*(\d+),\s*"error":\s*"([^"]*)",\s*"subMessage":\s*"([^"]*)",\s*"message":\s*"([^"]*)"\}/i, // sentry-config 内部抛出异常忽略
    "null is not an object (evaluating 'ifameElement.contentDocument.addEventListener')", // 新增：忽略 responseText + responseType 相关的 InvalidStateError
    /Failed to read the 'responseText' property from 'XMLHttpRequest': The value is only accessible if the object's 'responseType' is '' or 'text' \(was 'json'\)/i, /Error: Java object is gone/i]
  });
  /**
   * 处理source透传
   */

  if (query.source) {
    Cookie.set('teacherSource', query.source, {
      expires: 0.1
    });
  } // 神策全局配置


  try {
    var ua = window.navigator.userAgent;
    var platform_1 = '其他';
    var isWx = /MicroMessenger/i.test(ua);
    var isMiniApp = /miniprogram/i.test(ua);

    if (isWx && isMiniApp) {
      platform_1 = '微信小程序';
    } else if (isWx) {
      platform_1 = '微信内';
    } else if (/JoJoVersion/i.test(ua)) {
      platform_1 = 'APP内';
    }

    window.sensorsExpoSure = sensors.use(Exposure, {
      area_rate: 0,
      stay_duration: 0,
      repeated: true
    }); // 注册sensors

    sensors.tinmanSensorsInit({
      lob: 'marketing',
      env_name: envName || 'dev',
      show_log: false,
      server_url: sensors_server_url,
      autoTrackSet: function autoTrackSet() {
        sensors.quick('isReady', function () {
          var _a;

          var _state = ((_a = sensors === null || sensors === void 0 ? void 0 : sensors.store) === null || _a === void 0 ? void 0 : _a._state) || {
            $device_id: ''
          }; // 注册公共属性


          sensors.registerPage({
            custom_platform: platform_1,
            $device_id: _state.$device_id
          });
        });
        return false;
      }
    }); // 绘本那边可能没有登录，我们需要把匿名ID跟他们对齐

    sensors.quick('isReady', function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var _a, status_1, data, e_1;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _b.trys.push([0, 3,, 4]);

              if (!(!uid_1 && canUseBridge)) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , bridge.call('deviceInfo')];

            case 1:
              _a = _b.sent(), status_1 = _a.status, data = _a.data;

              if (status_1 === 200 && data.UUID) {
                sensors.identify(data.UUID, true);
              }

              _b.label = 2;

            case 2:
              return [3
              /*break*/
              , 4];

            case 3:
              e_1 = _b.sent();
              customError({
                name: '矩阵APP神策初始化错误',
                message: e_1.message,
                stack: e_1.stack
              });
              return [3
              /*break*/
              , 4];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    });
    window.sensors = sensors;
  } catch (e) {
    customError({
      name: 'sensors初始化错误',
      message: e.name || e.message || '运行错误',
      stack: e.stack
    });
  } // 用于混淆手机号验证码数据，之所以写在这里，是为了迷惑黑产


  window.ype = function (str) {
    return window.btoa(unescape(encodeURIComponent(str)));
  };

  window.ent = function () {
    var arr = [];

    for (var index = 34; index < 122; index += 1) {
      arr.push(index);
    }

    return arr.sort(function () {
      return Math.random() - 0.5;
    });
  };
} catch (e) {
  customError({
    name: 'global.ts错误',
    message: e.name || e.message || '运行错误',
    stack: e.stack
  });
}